import { action } from "mobx";
import moment from "moment";

export default class ProjectCostEstimates {
  constructor(store, object) {
    this.store = store;
    this.projectCostId = null;
    this.name = null;
    this.owner = null;
    this.createdDate = null;
    this.createdDisplay = null;
    this.projectStats = [];
    // providing options for selecting and editing
    this.viewState = {
      selected: false,
      editing: false,
    };
    this.tags = {};
    this.user = null;

    if (object) {
      this.projectCostId = object.projectId || null;
      this.name = object.name || null;
      this.owner = `${object.user.firstName} ${object.user.lastName}` || null;
      this.createdDate = moment(object.created);
      this.createdDisplay = `Created ${this.createdDate.format("MMMM D, YYYY")}`; // Required format for Date
      this.projectStats = object.projectStats;
      this.tags = object.tags;
      this.user = object.user;
    }
    this.toggleEdit = action(this.toggleEdit.bind(this));
    this.toggleSelected = action(this.toggleSelected.bind(this));
    this.destroy = action(this.destroy.bind(this));
  }

  toggleEdit() {
    const viewState = this.store.projectCostsViewState.get(this.projectCostId);
    viewState.editing = !viewState.editing;
  }

  toggleSelected(e, ignore1 = null, ignore2 = null, setValue = null) {
    const viewState = this.store.projectCostsViewState.get(this.projectCostId);

    if (setValue !== null) {
      viewState.selected = setValue;
      return;
    } else {
      viewState.selected = !viewState.selected;

      if (!viewState.selected && this.store.allSelected) {
        this.store.allSelected = false;
      }
    }

    if (!this.store.allowMultipleItemSelection) {
      // deselect all other projects
      this.store.projectCostsViewState.forEach((viewState) => {
        if (this.viewState === viewState) return;

        viewState.selected = false;
      });
    }
  }

  // destroy the selected projects
  destroy() {
    this.store.projects.remove(this);
  }

  toJS() {
    return {
      projectCostId: this.projectCostId,
      name: this.name,
    };
  }

  static fromJS(store, object) {
    return new ProjectCostEstimates(store, object);
  }
}
